import {reactive} from "vue";
import GameManager from "@/assets/js/GameManager";
import {Action} from "@/assets/js/action";
import store from "@/store/store"

export class Patient {
    time = 300;
    death_callback = null;
    state = "normal"; // Options: normal, selected, dead, healed
    show_physical_exam = false;
    initialized_labs = [];
    initialized_treatments = [];
    activated_combos = [];
    quiz_responses = [];
    disabled_buttons = [];
    fluid_intake = 0;
    constructor(_patient, _death_callback, _actions_in_progress) {
        Object.assign(this, _patient);
        if(this.time === 300) this.time = this.health;
        this.death_callback = _death_callback;
        if(_actions_in_progress){
            _actions_in_progress.forEach(action=>{
                this.doAction(action.action, action.elapsed, true);
            });
        }
    }

    // due to scope limitations of Vue.reactive(), initialize() must be called by the
    // function that creates the 'new Patient()' instead of in the constructor
    initialize(){
        window.requestAnimationFrame(this.tick.bind(this));
    }

    tick(){
        if(!GameManager.paused){
            if(this.time > 0){
                this.time -= this.modifiedHealthRate * GameManager.timeDelta / 1000; // divide by 1000 to normalize to seconds instead of ms
            }
            if(this.time <= 0){
                this.time = 0;
                this.patientDeath();
                return;
            }
            if(this.time > 300){
                this.patientHealed();
                return;
            }
        }
        window.requestAnimationFrame(this.tick.bind(this));
    }

    get computed_vitals(){
        let vitals = {}
        let news = 0;
        this.vitals.map(element=>{
            let percent, value;
            let health = this.time;
            if(health > 200){
                percent = (health-200)/100;
                value = ((element.at300 - element.at200) * percent) + element.at200;
            } else if(health > 100) {
                percent = (health-100)/100
                value = ((element.at200 - element.at100) * percent) + element.at100;
            } else {
                percent = health/100
                value = ((element.at100 - element.at0) * percent) + element.at0;
            }
            // console.log(this.name + "'s " + element.name + " of " + value + " returns NEWS value of " + this.getNewsAdjustment(element.name, value));
            news += this.getNewsAdjustment(element.name, value);
            if(element.type === "decimal1"){
                vitals[element.name] = value.toFixed(1)
            } else {
                vitals[element.name] = Math.round(value);
            }
        });
        // console.log(news);
        vitals.news = news;
        vitals.sofa = this.getSofaScore(vitals.SBP, vitals.DBP, vitals.GCS, vitals["Urine Out"], vitals["Weight"]);
        return vitals;
    }
    get physicalExam(){
        let exam = this.tests.find(test => test.labID==="physicalexam" )
        return this.show_physical_exam ? exam.result : store.getters['getUIText']('physicalexamhasnotb');
    }
    get finishedLabs(){
        let complete = this.initialized_labs.filter(lab=>lab.complete)
        if(complete.length > 0){
            let results = [];
            for(let i = 0; i < complete.length; i++){
                let result = this.getLabResultFor(complete[i].id, complete[i].health)
                let group = {
                    name: complete[i].name,
                    results: result
                };
                results.push(group);
            }
            return results;
        }
        return [];
    }
    get incompleteLabs(){
        return this.initialized_labs.filter(lab=>!lab.complete)
    }
    get finishedTreatments(){
        return this.initialized_treatments.filter(treatment=>treatment.complete);
    }
    get incompleteTreatments(){
        return this.initialized_treatments.filter(treatment=>!treatment.complete);
    }
    get incompleteCombos(){
        //let treat_ids = this.incompleteTreatments.map(x=>x.id);
        let combos = []
        for(let i = 0; i < this.activated_combos.length; i++){
            // if(this.activated_combos[i].ids.some(v => treat_ids.indexOf(v) >= 0)){
            //     //console.log("Active combo: ", this.activated_combos[i]);
            //     combos.push(this.activated_combos[i]);
            // }
            if(this.checkCombo(this.activated_combos[i])){
                combos.push(this.activated_combos[i]);
            }
        }
        //console.log(combos);
        return combos;
    }
    get quizResponses(){
        return this.quiz_responses;
    }
    get modifiedHealthRate(){
        let mod = 0;
        mod += this.healthRate;
        this.incompleteTreatments.forEach(treat=>{
            let treatment = this.treatments.find(i=>i.id === treat.id);
            // console.log("Treatment:", treatment);
            if(this.time <= 100 && typeof treatment.valueBelow100 === 'number' && !isNaN(treatment.valueBelow100)){
                // console.log("Under 100", treatment.valueBelow100)
                mod -= treatment.valueBelow100;
            } else if (this.time <= 200 && typeof treatment.valueBelow200 === 'number' && !isNaN(treatment.valueBelow200)){
                // console.log("Under 200", treatment.valueBelow200, isNaN(treatment.valueBelow200))
                mod -= treatment.valueBelow200;
            } else {
                // console.log("Under 300")
                mod -= treatment.value;
            }
        });
         this.incompleteCombos.forEach(combo=>{
             if(combo.health < 100 && combo.below100){
                 mod -= combo.below100;
             } else if (combo.health < 200 && combo.below200){
                 mod -= combo.below200;
             } else {
                 mod -= combo.value;
             }
         });

        return mod;
    }

    getLabById(id){
        let output = this.tests.filter(test=>{
            return test.id === id;
        })
        console.log(output)
    }
    getTreatmentById(id){
        let output = this.treatments.filter(test=>{
            return test.id === id;
        })
        console.log(output)
    }

    getNewsAdjustment(type, value){
        switch(type){
            case "RR":
                if(value <= 8 || value >= 25){
                    return 3;
                } else if(value >= 21){
                    return 2;
                } else if(value <= 11){
                    return 1;
                } else {
                    return 0;
                }
            case "SBP":
                if(value <= 90){
                    return 3;
                } else if(value <= 100){
                    return 2;
                } else if(value <= 110 || value >= 250){
                    return 1;
                } else {
                    return 0;
                }
            case "HR":
                if(value >= 131){
                    return 3;
                } else if(value <=40 || value >= 111){
                    return 2;
                } else if(value <= 50 || value >= 91){
                    return 1;
                } else {
                    return 0;
                }
            case "Temp":
                if(value <= 35){
                    return 3;
                } else if(value >= 39.1){
                    return 2;
                } else if(value <= 36 || value >= 38.1){
                    return 1;
                } else {
                    return 0
                }
            case "GCS":
                if(value <= 14) {
                    return 3;
                }
                return 0;
            default:
                return 0;
        }
    }

    getSofaScore(SBP, DBP, GCS, UO, weight){
        //let labIds = ['cbc', 'cmp', 'abg'];
        let sofa = 0;
        let complete = this.initialized_labs.filter(lab=>lab.complete)
        if (complete.length === 0) return store.getters["getUIText"]("unknown");
        // Respiration: abg['ABG O2']/0.21
        let all_labs = "";
        let abg = complete.find(item=>item.id==='abg');
        if(abg){
            let abgTerms = ['ABG O2', "Gazométrie O2"];
            let abg_result = this.getLabResultFor('abg', abg.health).find(a=>abgTerms.indexOf(a.name) > -1).actual / 0.21;
            // let abg_result = this.getLabResultFor('abg', abg.health).find(a=>a.name==='ABG O2').actual / 0.21;
            if(abg_result < 100) {
                sofa += 4;
            } else if(abg_result < 200) {
                sofa += 3;
            } else if(abg_result < 300) {
                sofa += 2
            } else if(abg_result < 400) {
                sofa += 1;
            }
        } else { all_labs = " (" + store.getters["getUIText"]("incomplete") + ")"; }
        // Platelets: cbc['CBC Platelet']
        let cbc = complete.find(item=>item.id==='cbc');
        if(cbc){
            let cbcTerms = ["CBC Platelet", "FSC Thrombocytes"]
            let cbc_result = this.getLabResultFor('cbc', cbc.health).find(a=>cbcTerms.indexOf(a.name) > -1).actual;
            // let cbc_result = this.getLabResultFor('cbc', cbc.health).find(a=>a.name==="CBC Platelet").actual;
            if(cbc_result < 20) {
                sofa += 4;
            } else if(cbc_result < 50) {
                sofa += 3;
            } else if(cbc_result < 100) {
                sofa += 2;
            } else if(cbc_result < 150) {
                sofa += 1;
            }
        } else { all_labs = " (" + store.getters["getUIText"]("incomplete") + ")"; }
        // Bilirubin: cmp['LFT Total Bilirubin']
        // Creatinine: cmp['BMP Creatinine']
        let cmp = complete.find(item=>item.id==='cmp');
        if(cmp){
            let cmp_results = this.getLabResultFor('cmp', cmp.health)
            let bili = cmp_results.find(a=>a.name==="LFT Total Bilirubin").actual;
            if(bili > 12) {
                sofa += 4;
            } else if(bili > 6){
                sofa += 3;
            } else if(bili > 2){
                sofa += 2;
            } else if(bili > 1.2){
                sofa += 1;
            }
            let creatinine = cmp_results.find(a=>a.name==="BMP Creatinine").actual;
            if(creatinine > 5){
                sofa += 4;
            } else if(creatinine > 3.5){
                sofa += 3;
            } else if(creatinine > 2){
                sofa += 2;
            } else if(creatinine > 1.2){
                sofa += 1;
            }
        } else { all_labs = " (" + store.getters["getUIText"]("incomplete") + ")"; }
        // Cardiovascular: (vitals.SBP + (2 * vitals.DBP))/3
        let map = (SBP + (2 * DBP))/3
        if(map > 70) sofa += 1;
        // Glasgow Coma Scale: Forthcoming
        if (GCS < 6) {
            sofa += 4;
        } else if (GCS <= 9){
            sofa += 3;
        } else if (GCS <= 12){
            sofa += 2;
        } else if (GCS <= 14){
            sofa += 1;
        }
        // Urine Output: vitals['Urine Out']
        // UO is in ml per kg per hr. Need to convert to ml/day
        let urine = UO * weight * 24;
        if(urine < 200) {
            sofa += 4
        } else if (urine < 500){
            sofa += 3;
        }

        return sofa + all_labs;
    }

    doAction(action, elapsed, loading = false){
        if(this.isButtonDisabled(action.text)){
            return;
        }
        if(action.lab && action.lab === "physicalexam") {
            this.show_physical_exam = true;
            if(GameManager.tutorial){
                this.showTutorialModal("greatnowletslearnab","youmaybewonderingwh")
            }
        } else if(action.lab) {
            if(loading){
                this.getLabById(action.id);
            }
            let merged = Object.assign(store.getters["getActionById"](action.lab), action);
            this.doLab(merged, elapsed, loading);
        } else if(action.treatment) {
            let filtered = this.initialized_treatments.filter(item=> {
                return item.id === action.treatment
            })
            console.log(filtered.length);
            if(filtered.length >= action.usesperpatient){
                GameManager.addAlert(store.getters["getUIText"]("youcannotperform"));
                return;
            }
            if(loading){
                this.getTreatmentById(action.treatment)
            }
            let buttonData = store.getters["getActionById"](action.treatment);
            console.log(action.treatment, buttonData, action);
            Object.assign(buttonData, action);
            this.doTreatment(buttonData, elapsed, loading);
            if(action.tutorialTip){
                this.showTutorialModal(action.tutorial_tip.header, action.tutorial_tip.text)
            }
        }
        if(action.unlock){
            action.unlock.forEach(item=>{
                this.enableButton(item)
            })
        }
    }
    doLab(action, elapsed, loading){
        // console.log("Doing Lab", action);
        let tutorial_callback;
        if(action.tutorial_tip){
            tutorial_callback = ()=>{
                this.showTutorialModal(action.tutorial_tip.header, action.tutorial_tip.text)
                // GameManager.showTutorialTip(action.tutorial_tip);
            }
        }
        let lab = reactive(new Action(action.text, action.lab, action.duration, this.time, tutorial_callback, elapsed, action.timestamp));
        window.requestAnimationFrame(lab.tick.bind(lab.that));
        this.initialized_labs.push(lab);
        let tip = this.getLabTipFor(action.lab, this.time);
        if(tip && !loading){
            GameManager.showTip(tip);
            lab.tip = tip;
        } else if(!loading) {
            GameManager.saveGame();
        }
    }
    doTreatment(action, elapsed, loading){
        let saline_list = {"d5halfnormalsaline500cc": 0.5, "ivnormalsaline500ml": 0.5, "ivnormalsaline1000ml": 1};
        // Don't allow the same treatment more than once
        if(this.incompleteTreatments.find(el=>el.id === action.treatment)){
            GameManager.addAlert(store.getters["getUIText"]("youhavealreadyorder"));
            return;
        }
        // Only allow one saline at a time
        if(Object.keys(saline_list).indexOf(action.treatment) >= 0){
            if(this.fluid_intake >=3){
                GameManager.addAlert(store.getters["getUIText"]("continuedsalinerisk"));
                return;
            }
            else if(this.incompleteTreatments.filter(el=>Object.keys(saline_list).indexOf(el.id) >= 0).length > 0){
                GameManager.addAlert(store.getters["getUIText"]("youcanonlyperformon"));
                return;
            }
            else {
                this.fluid_intake += saline_list[action.treatment];
            }
        }
        // console.log("Doing Treatment", action);
        let treatment = reactive(new Action(action.text, action.treatment, action.duration, this.time, () => {
            GameManager.addAlert(store.getters["getUIText"]("xhascompleted", action.text));
        }, elapsed, action.timestamp))
        window.requestAnimationFrame(treatment.tick.bind(treatment.that));
        this.initialized_treatments.push(treatment);
        let tip = this.getTreatmentTipFor(action.treatment, this.time);
        if(tip && !loading){
            GameManager.showTip(tip);
            treatment.tip = tip;
        } else if (!loading){
            GameManager.saveGame();
        }
        this.checkCombos(elapsed === undefined);
    }

    checkCombos(showTip){
        for (let i = 0; i < this.combos.length; i++) {
            // only check combos that haven't been completed already
            if(this.activated_combos.indexOf(this.combos[i]) < 0) {
                // create an array of which treatments in a combo have been initialized.
                if(this.checkCombo(this.combos[i])){
                    // console.log("Combo complete!", this.combos[i]);
                    this.combos[i].health = this.time;
                    this.activated_combos.push(this.combos[i]);
                    if(this.combos[i].response && showTip){
                        GameManager.showTip({response: this.combos[i].response, score: this.combos[i].score || 0, image: this.combos[i].image })
                    }
                }
            }
        }
    }
    checkCombo(combo){
        let completed = this.incompleteTreatments.filter(treatment=>{
            return combo.ids.indexOf(treatment.id) >= 0;
        });
        return completed.length >= combo.number;
    }

    getLabTipFor(id){
        let lab = this.tests.find(i=>i.labID === id);
        return lab.tip;
    }
    getLabResultFor(id, health){
        let labs = this.tests.filter(lab=>lab.labID === id);
        return labs.map(lab=>{
            let processed = {};
            processed.name = lab.name;
            if(lab.result){
                processed.text = lab.result;
            } else if(health >= 200) {
                let difference = lab.at300 - lab.at200;
                let percent = (health -200)/100;
                processed.actual = lab.at200 + (difference * percent)
                processed.text = this.roundNumber(lab.at200 + (difference * percent), lab.type);
            } else if(health >= 100) {
                let difference = lab.at200 - lab.at100;
                let percent = (health -100)/100;
                processed.actual = lab.at100 + (difference * percent)
                processed.text = this.roundNumber(lab.at100 + (difference * percent), lab.type);
            } else {
                let difference = lab.at100 - lab.at0;
                let percent = health/100;
                processed.actual = lab.at0 + (difference * percent)
                processed.text = this.roundNumber(lab.at0 + (difference * percent), lab.type);
            }
            return processed;
        });
    }
    getTreatmentTipFor(id, health){
        // console.log("getting treatment: ", id, health);
        // console.log(this.treatments);
        let treatment = this.treatments.find(treat=>treat.id === id);
        if(health <= 100 && treatment.below100){
            return treatment.below100;
        } else if (health <= 200 && treatment.below200){
            return treatment.below200;
        }
        return treatment.below300;
    }
    addQuizResponse(response){
        this.quiz_responses.push(response);
    }
    roundNumber(num, type){
        switch (type){
            case "decimal3":
                return num.toFixed(3);
            case "decimal2":
                return num.toFixed(2);
            case "decimal1":
                return num.toFixed(1);
            case "string":
                return num;
            default:
                return Math.round(num);
        }
    }

    patientSelect(select){
        if(this.state === "dead" || this.state === "healed"){
            return;
        }
        this.state = select ? "selected" : "normal";
    }
    patientDeath(){
        this.state = "dead";
        this.endState = this.death_tip;
        store.commit("addCompletePatient", this.createSave());
        if(this.death_callback){
            this.death_callback.call(this, this.death_tip);
        }
        if(GameManager.patients[GameManager.selectedSlot] === this){
            GameManager.selectedSlot = -1;
        }
    }
    patientHealed(){
        // console.log("Healed patient in slot " + GameManager.patients.indexOf(this));
        GameManager.showTip(this.healed_tip);
        this.state = "healed";
        this.endState = this.healed_tip;
        store.commit("addCompletePatient", this.createSave());
        if(GameManager.patients[GameManager.selectedSlot] === this){
            GameManager.selectedSlot = -1;
        }
    }

    disableButton(id){
        if(this.disabled_buttons.indexOf(id) < 0){
            this.disabled_buttons.push(id);
        }
    }
    enableButton(id){
        if(this.disabled_buttons.indexOf(id) >= 0){
            this.disabled_buttons.splice(this.disabled_buttons.indexOf(id), 1);
        }
    }

    isButtonDisabled(id){
        return this.disabled_buttons.indexOf(id) > -1;
    }

    showTutorialModal(header_id, text_id){
        GameManager.showTutorialTip({
            header: store.getters["getUIText"](header_id),
            text: store.getters["getUIText"](text_id)
        })
    }

    // create JSON object to be included in save data
    createSave(){
        // console.log("Creating Patient Save");
        let saveData = {};
        saveData.health = this.time;
        saveData.name = this.name;
        saveData.actions = [];
        saveData.endState = this.endState;
        this.initialized_labs.forEach(lab=>{
            let data = lab.createSaveData();
            data.action.lab = data.action.id;
            saveData.actions.push(data);
        });
        this.initialized_treatments.forEach(treat=>{
            let data = treat.createSaveData()
            data.action.treatment = data.action.id;
            // console.log(data);
            saveData.actions.push(data)
        });
        saveData.quiz_responses = this.quiz_responses;
        // console.log(saveData);
        return saveData;
    }
}
